module.exports = __webpack_public_path__ + "static/media/download-app.0489aeee.svg";